import { ServerFetch } from '../main-model'

export default class ExpensesNoteListModel extends ServerFetch {
    getExpensesNoteListBy = (data) => this.authFetch({
        url: 'expenses-note-list/getExpensesNoteListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}